export default {_name:'card.simple.small',module:'Field',view:'Element/Card/Small',webOptions:{xs:12},mobileOptions:{ms:12}}